/* 
eslint-disable no-mixed-operators
*/
import React from 'react';
import { applyWindowProps } from '../../../util';

const WindowProps = React.memo(
	(props) => {
		React.useEffect(() => {
			applyWindowProps(props);
		},[]); //eslint-disable-line react-hooks/exhaustive-deps
		return null;
	}
);

export default WindowProps;